import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import MunicipalitiesMenu from '../components/municipalities/MunicipalitiesMenu.vue';
import MunicipalitiesList from '../components/municipalities/MunicipalitiesList.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'MunicipalitiesView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MunicipalitiesMenu),
    _createVNode(MunicipalitiesList)
  ], 64))
}
}

})